import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/block_list'),
      roles: ['administrator'],
      component: () => import('../Wrapper'),
      props: {
        headerTitle: 'BLOCK_LIST.TITLE',
        icon: 'block',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'block_list',
          component: () => import('./Index.vue'),
          roles: ['administrator'],
          meta: {
            permission: 'block_contacts',
          },
        },
      ],
    },
  ],
};
